import { StyleSet } from '../models';

export const LessonUpStyleSets: StyleSet[] = [
  {
    id: 'body',
    name: 'Body',
    colors: [],
    styles: [
      {
        fontFamily: 'Dm Sans',
        fontSize: '24px',
      },
    ],
  },
  {
    id: 'small',
    name: 'Body',
    colors: [],
    styles: [
      {
        fontFamily: 'Dm Sans',
        fontSize: '14px',
      },
    ],
  },
  {
    id: 'title',
    name: 'Title',
    colors: [],
    styles: [
      {
        fontFamily: 'Plus Jakarta Sans',
        fontSize: '32px',
      },
    ],
  },
  {
    id: 'subtitle',
    name: 'Sub Title',
    colors: [],
    styles: [
      {
        fontFamily: 'Dm Sans',
        fontSize: '24px',
      },
    ],
  },
];
